interface LabelProps {
	type?: "Primary" | "Secondary" | "Dark" | "Warning";
	children: React.ReactNode;
	className?: string;
}

const Label = ({ type = "Primary", children, className = "" }: LabelProps) => {
	const getTypeStyles = () => {
		switch (type) {
			case "Primary":
				return "bg-color-Primary50 text-color-Primary500 border-color-Primary100";
			case "Secondary":
				return "bg-color-Grey50 text-color-Grey500 border-color-Grey100";
			case "Dark":
				return "bg-color-Grey900 text-white border-color-Grey900";
			case "Warning":
				return "bg-color-Yellow50 text-color-Yellow600 border-color-Yellow100";
			default:
				return "bg-color-Primary50 text-color-Primary500 border-color-Primary100";
		}
	};

	return (
		<span
			className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium border ${getTypeStyles()} ${className}`}
		>
			{children}
		</span>
	);
};

export { Label };
